import React, { useEffect } from 'react';
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types';
import Dragger from 'draggerjs';
import { Chaperone, ChaperoneStep } from 'chaperone';
import { Link } from 'reaouter';
import { css, addClass, removeClass, selectEl } from 'Common/Utils';

const TourGuide = [
	{
		index: 0,
		message: "you can click this indicator to show the sidebar.",
		placement: "right-bottom",
		find:(target) => selectEl(".mobile-tip-pan", target),
		onLoad: () => {
			selectEl('.nav-sidebar').style.zIndex = '1000000'
		},
		onUnLoad: () => {
			selectEl('.nav-sidebar').style.zIndex = null
		}
	},
	{
		index: 1,
		message: "you can also slide in your 2 finger tip to show the sidebar.",
		placement: "right-top", 
		isDone: true,
		gesture:  (
			<div className="custom-click-gesture">
				<i className="mytabworks icon-hand-peace"/>
			</div>
		)
	}
]
const Sidebar = ({ links, children }) => {
	useEffect(() => { 
		let dragger, cleanUp, isComplete = false, isSideWays = false, isMove = false,
			isDestroy = false, fingerpan = selectEl('.mobile-tip-pan'), mobileTipDown, mobileTipUp
		const media = window.matchMedia('(max-width: 1025px)') 
		const mobile = window.matchMedia('(max-width: 500px)') 
		const handleMedia = () => { 
			if(media.matches && !isDestroy) {
				
				const backdrop = selectEl('#nav-sidebar-backdrop')
				const sidebar = selectEl('.nav-sidebar')
				const content = selectEl('.content') 
				const bunch = [sidebar, backdrop] 
				dragger = new Dragger(sidebar, {
					allowBoundContainer: false
				})
				dragger.on('dragstart', (e) => { 
					if(!e.target.matches('.side-nav *')) e.preventDefault()
					css(sidebar, 'left', `${isComplete ? 0 : -sidebar.clientWidth}px`)
					bunch.forEach((el) => {
						addClass(el, 'grabbed')
						removeClass(el, 'transition')
					}) 
					
					if(!mobile.matches) {
						const contentTotal = (isComplete ? sidebar.clientWidth : 0)
						css(content, {
							marginLeft: `${contentTotal}px`, 
							width: `calc(100% - ${contentTotal}px)` 
						})
						removeClass(content, 'transition')
					}
					clearTimeout(cleanUp)
				})
				dragger.on('dragmove', (e) => {
					if(!isMove) {
						isSideWays = (e.moveX > e.startX ? e.moveX - e.startX : e.startX - e.moveX) > (e.moveY > e.startY ? e.moveY - e.startY : e.startY - e.moveY) || !isComplete
						isMove = true
					}
					if(!isSideWays) return
					const width = sidebar.clientWidth  
					const distance = (isComplete ? e.moveX - e.startX : (e.moveX - e.startX) - width) 
					css(backdrop, 'opacity', (width - Math.min(width, Math.abs(Math.min(0, distance))))/(width * 1.3))
					css(sidebar, 'left', `${0 > distance ? -width > distance ? -width : distance : 0}px`)
					if(!mobile.matches) {
						const contentDistance = width + distance
						const contentTotal = (0 < contentDistance ? width < contentDistance ? width : contentDistance : 0)
						css(content, {
							marginLeft: `${contentTotal}px`, 
							width: `calc(100% - ${contentTotal}px)` 
						})
					}
				}) 
				dragger.on('dragend', (e) => {
					const fingerpanEvent = e.type === 'touchend'
					isMove = false
					setTimeout(() => bunch.forEach((el) => { 
						removeClass(el, 'grabbed')
					}) , 0)
					if(!isSideWays && !fingerpanEvent) return
					const width = sidebar.clientWidth 
					const distance = isComplete ? (e.endX - e.startX) + width :  e.endX - e.startX 
					if(distance > sidebar.clientWidth/(isComplete ? 1.2: 2) || fingerpanEvent) { 
						bunch.forEach((el) => { 
							addClass(el, 'show')
						})
						mobile.matches || addClass(content, 'show')
						isComplete = true
					} else {  
						bunch.forEach((el) => { 
							removeClass(el, 'show')
						})
						removeClass(content, 'show') 
						isComplete = false
					}
					/*didn't do bunch here because it is not transitioning in mobile chrome*/
					addClass(backdrop, 'transition')
					addClass(sidebar, 'transition') 
					mobile.matches || addClass(content, 'transition')
					css(sidebar, 'left', null) 
					css(backdrop, 'opacity', null) 
					css(content, {
						marginLeft: null, 
						width: null 
					}) 
					cleanUp = setTimeout(() => {
						removeClass(sidebar, 'transition') 
						mobile.matches || removeClass(content, 'transition')
					}, 300) 
					
				})
				mobileTipDown = (e) => {
					e.preventDefault()
					e.stopPropagation()
				} 
				mobileTipUp = (e) => dragger.emitters.dragend(e)
				fingerpan.addEventListener('touchstart', mobileTipDown)
				fingerpan.addEventListener('touchend', mobileTipUp)
			} else {
				dragger && dragger.destroy()
				fingerpan.removeEventListener('touchstart', mobileTipDown)
				fingerpan.removeEventListener('touchend', mobileTipUp)
			}
		}
		handleMedia()
		media.addListener(handleMedia)
		return () => {
			media.removeListener(handleMedia)
			isDestroy = true
			handleMedia()
		}
	}, [])

	const mobileMode = window.matchMedia('(max-width: 1025px)').matches
	
	const handleChaperone = () => { 
		window.localStorage.setItem('dm-sidebar', true)
	}

	return (
		<div className='nav-sidebar'>
			<nav className="side-nav flex-column">
				{children || links.map(({ to, label, undev, ...props }) => (
					<Link key={label} className="n-btn" to={to} label={
						undev ? (
							<>
								<i className="mytabworks icon-wrench"/>
								{label} 
							</>
						) : label} {...props} />
				))}
			</nav>
			<Chaperone autoTrigger={mobileMode && !window.localStorage.getItem('dm-sidebar')} id="dm-sidebar" onSkip={handleChaperone} onDone={handleChaperone}>
				<ChaperoneStep id="dm-sidebar" propertyMutation={({ index }, defaultProps) => {
					return {
						...defaultProps,
						...TourGuide.find((props) => props.index === index)
					}
				}}>
					<div className="mobile-tip">
						<div className="mobile-tip-pan n-bg n-bordered">
							<i className="mytabworks icon-burger" />
						</div>
					</div>
				</ChaperoneStep>
			</Chaperone>
			{ReactDOM.createPortal(<div id="nav-sidebar-backdrop" className="mobile-backdrop" />, document.body)}
			<p className="copyright">© 2020 Mytabworks.</p>
		</div>
	);
};

Sidebar.propTypes = {
	links: PropTypes.arrayOf(
		PropTypes.shape({ to: PropTypes.string, label: PropTypes.string })
	),
	children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)])
};

export default Sidebar;
